
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Settings, Lock, LogOut } from 'lucide-react';
import { AdminLoginDialog } from './admin-login-dialog';
import { useAdminAuth } from '@/hooks/use-admin-auth';
import { useNavigate } from 'react-router-dom';

export function AdminButton() {
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const { isAdmin, loading, login, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleAdminClick = () => {
    if (isAdmin) {
      navigate('/admin');
    } else {
      setLoginDialogOpen(true);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <Button
        variant="ghost"
        className="w-full justify-start text-sidebar-foreground gap-2"
        onClick={handleAdminClick}
      >
        {isAdmin ? <Settings className="h-5 w-5" /> : <Lock className="h-5 w-5" />}
        <span>{isAdmin ? 'Administrator' : 'Admin-tilgang'}</span>
      </Button>

      {isAdmin && (
        <Button
          variant="ghost"
          className="w-full justify-start text-sidebar-foreground gap-2 text-muted-foreground"
          onClick={handleLogout}
        >
          <LogOut className="h-5 w-5" />
          <span>Logg ut admin</span>
        </Button>
      )}

      <AdminLoginDialog
        open={loginDialogOpen}
        onOpenChange={setLoginDialogOpen}
        onLogin={login}
      />
    </>
  );
}
